
const ExpertiseSection = () => {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'SEO Domination',
      description: 'Advanced SEO strategies that get you to page 1 and keep you there. Technical optimization, content strategy, and link building that works.',
      features: ['Technical SEO Audit', 'Keyword Research & Strategy', 'Content Optimization', 'Local SEO Setup'],
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: 'ri-store-3-line',
      title: 'E-commerce Launch',
      description: 'Transform your local business into a thriving online store. Complete setup, optimization, and launch strategy for maximum impact.',
      features: ['Store Setup & Design', 'Product Optimization', 'Payment Integration', 'Mobile Optimization'],
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Growth Acceleration',
      description: 'Scale your existing e-commerce business across the US market. Data-driven strategies for explosive growth and market domination.',
      features: ['Conversion Optimization', 'Ad Campaign Management', 'Analytics Setup', 'Performance Tracking'],
      color: 'from-green-500 to-teal-600'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-indigo-50 border border-indigo-200 rounded-full text-indigo-700 text-sm font-medium mb-6">
            <i className="ri-star-line mr-2"></i>
            Our Expertise
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Three Paths to
            <span className="text-indigo-600"> Digital Success</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Whether you're going online for the first time or scaling to new heights, we have the expertise to get you there.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4 border border-gray-100">
              {/* Gradient Background */}
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
              
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700" style={{ fontFamily: 'Inter, sans-serif' }}>
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <button className="mt-8 w-full bg-gray-900 text-white py-3 rounded-xl font-semibold hover:bg-indigo-600 transition-colors duration-300 whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
                Learn More
              </button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <button className="bg-indigo-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-indigo-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap" style={{ fontFamily: 'Inter, sans-serif' }}>
            <i className="ri-calendar-line mr-2"></i>
            Book Your Strategy Session
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
